import { Fragment, useMemo } from 'react'
import { defineMessages, FormattedMessage, useIntl } from 'react-intl'
import { connect } from 'react-redux'
import {
  PackageExtra,
  PackageFooter,
  PackageInclusionsGroup,
} from '../PackageItems'
import isEmpty from 'lodash/isEmpty'

const messages = defineMessages({
  forDiversOnly: {
    id: 'for_divers_only',
    defaultMessage: 'For divers only',
  },
  forAllPassengers: {
    id: 'for_all_passengers',
    defaultMessage: 'For all passengers',
  },
  approxRangeDives: {
    id: 'booking_info.aprox_range_dives',
    defaultMessage: 'Approximately { divesMin } - { divesMax } dives per diver',
  },
  approxDives: {
    id: 'booking_info.aprox_dives',
    defaultMessage: 'Approximately { divesMin } dives per diver',
  },
  included: {
    id: 'included',
    defaultMessage: 'Included',
  },
  totalPriceForCabins: {
    id: 'total_price_for_cabins',
    defaultMessage: 'Total price for cabins',
  },
})

const BookingDetailsLiveaboardPackage = ({ order, selectedShop, isCheckout }) => {
  const intl = useIntl()

  const { itemsIncluded, currency, freeInsurance, cabinOverview, taxPercent } = order
  const totalNumberOfDivesMax = isEmpty(selectedShop) ? order?.totalNumberOfDivesMax : selectedShop?.totalNumberOfDivesMax
  const totalNumberOfDives = isEmpty(selectedShop) ? order?.totalNumberOfDives : selectedShop?.totalNumberOfDives

  const divesIncludedTitle = totalNumberOfDivesMax ? (
    <FormattedMessage
      {...messages.approxRangeDives}
      values={{
        divesMin: totalNumberOfDives,
        divesMax: totalNumberOfDivesMax,
      }}
    />
  ) : (
    <FormattedMessage
      {...messages.approxDives}
      values={{
        divesMin: totalNumberOfDives,
      }}
    />
  )

  const itemsIncludedDiver = useMemo(
    () => [
      {
        title: divesIncludedTitle,
        isIncluded: true,
      },
      ...itemsIncluded.filter((item) => item.isDiverItem),
    ],
    [order, selectedShop],
  )
  const itemsIncludedNonDiver = useMemo(
    () => itemsIncluded.filter((item) => item.isNonDiverItem),
    [order, selectedShop],
  )
  const getTotalCabinPrices = () => {
    const totalPrice = cabinOverview.reduce((sum, cabin) => (sum + Number(cabin.cabinSubtotal || cabin.cabinPrice)), 0)
    return isCheckout ? Math.ceil(totalPrice + totalPrice * taxPercent / 100) : totalPrice
  }
  return (
    <Fragment>
      <div className='price-pan__body no-border-top'>
        <PackageInclusionsGroup
          title={intl.formatMessage(messages.forDiversOnly)}
          items={itemsIncludedDiver}
        />
        <PackageInclusionsGroup
          title={intl.formatMessage(messages.forAllPassengers)}
          items={itemsIncludedNonDiver}
        />

        {!!freeInsurance && !!freeInsurance.length && (
          <PackageExtra item={freeInsurance[0]} isInsurance />
        )}
      </div>

      <PackageFooter
        message={intl.formatMessage(messages.totalPriceForCabins)}
        currency={currency}
        totalPrice={getTotalCabinPrices()}
      />
    </Fragment>
  )
}

export default connect((state) => ({ selectedShop: state.selectedShop }))(
  BookingDetailsLiveaboardPackage,
)
